import React from "react"
import moduleImporter from "AtomicUtils/moduleImporter"
import { rafThrottle, nullCheckProps } from "utils"

export { rafThrottle }

/**
 * @param {Object} props - True sets columns to full width.
 * @param {Function} additionalProps - Return props as a function of index.
 * @returns {Array} Array of React Component
 */
export const childParser = ({ children, components }, additionalProps = () => false) => {
  if (children) {
    return React.Children.map(children, (child, index) => {
      if (!child) return null
      if (additionalProps) {
        return React.cloneElement(child, additionalProps(index))
      }
      return child
    })
  }

  if (components) {
    return components.map(({ name, props }, index) =>
      renderComponent({
        name,
        props: {
          ...nullCheckProps(props),
          ...additionalProps(index),
          key: index
        }
      }))
  }
  return null
}

// For rendering flexible component given name and props
export const renderComponent = (component) => {
  const Component = moduleImporter(component.name)
  if (!Component) {
    console.error(`${component.name} tried to render but was not found. Please make sure ${
      component.name
    } is imported in /blocks`)
    return null
  }
  return <Component {...component.props} />
}



// WEBPACK FOOTER //
// ./src/containers/utilities/index.jsx